<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Modal :closable="false" :width="width+'px'" @on-visible-change="onVisibleChange" class="modal-setting scrollbar"
         class-name="vertical-center-modal"
         footer-hide v-model="modalShowHide">
    <p class="text-center" slot="header">
      <span>{{ getTitle }}</span>
    </p>
    <div class="w-full">
      <component :is="getSrcComponents" :multiple="multiple" :selectObj="selectObj" :modalShowHide="modalShowHide">
        <template v-if="srcTypeList.length>1" v-slot:leftBtn>
          <Select class="m-r-10 flex-s-0" style="width: 120px" v-model="srcId">
            <Option :key="item.id" :value="item.id" v-for="(item) in srcTypeList">{{item.name}}</Option>
          </Select>
        </template>
      </component>
      <div class="flex a-center j-center h-60">
        <Button @click="cancel()" style="width: 100px">取消</Button>
        <Button @click="ok()" style="margin-left: 30px;width: 100px" type="primary">确定</Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import {getList} from './srctype'
import PicLibWidget from './PicLibWidget'
import VideoLibWidget from './VideoLibWidget'
import IconLibWidget from './IconLibWidget'

export default {
  name: 'SourceChooseWidget',
  components: {IconLibWidget, VideoLibWidget, PicLibWidget},
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    chooseType: {
      type: Number,
      default: 7,
    },
    width: {
      type: Number,
      default: 1100,
    },
  },
  data () {
    return {
      srcId: 0,
      srcTypeList: [],
      modalShowHide: false,
      selectObj: {
        maps: new Map(),
        mapLength: 0
      }
    }
  },
  computed: {
    getTitle () {
      let text = '选择'
      let info = this.srcTypeList.find(e => {
        return e.id === this.srcId
      })
      if (info) {
        text = '选择' + (info.name)
      }
      return text
    },
    getSrcComponents () {
      let commentName = ''
      switch (this.srcId) {
        case 1:
          commentName = 'PicLibWidget'
          break
        case 2:
          commentName = 'VideoLibWidget'
          break
        case 3:
          commentName = 'IconLibWidget'
          break
      }
      this.selectObj = {
        maps: new Map(),
        mapLength: 0
      }
      return commentName
    }
  },
  watch: {
    chooseType: {
      handler (newValue) {
        if (newValue) {
          this.srcTypeList = getList(newValue)
          if (this.srcTypeList && this.srcTypeList.length) {
            this.srcId = this.srcTypeList[0].id
          }
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onVisibleChange (status) {
      if (!status) {
        this.selectObj = {
          maps: new Map(),
          mapLength: 0
        }
      }
    },
    cancel () {
      this.hide()
    },
    ok () {
      let data = []
      this.selectObj.maps.forEach((value) => {
        data.push({
          type: this.srcId,
          ...value
        })
      })
      console.log('selData=>', data)
      this.$emit('ok', data, () => {
        this.hide()
      })
    },
    show () {
      this.modalShowHide = true
    },
    hide () {
      this.modalShowHide = false
    },
  }
}
</script>

<style lang="scss" scoped>
  .modal-setting ::v-deep {

    .ivu-modal-header-inner {
      display: flex;
      justify-content: center;
      font-weight: bold;
    }

    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }
</style>
